import React, { SVGProps } from 'react'
export const ThirdActiveCenterSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="36"
    fill="none"
    viewBox="0 0 74 36"
    preserveAspectRatio="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M37.54 35.968c9.347 0 32.352.032 36.46.032V1.015c-11.527-2.417-23.463.442-35.091-.231C26.248.05 12.649-.981 0 2.014V36c8.581 0 27.132-.032 37.54-.032Z"
    />
  </svg>
)
